<!-- =========================================================================================
  File Name: link.vue
  Description: User Link
========================================================================================== -->

<template>
  <div id="user-link">

    <vx-card title="会员推广链接">

      <div slot="actions">
        <vx-input-group>
          <template slot="prepend">
            <vs-input class="w-48" v-model="uid" placeholder="用户名 / UID" />
          </template>
          <template slot="append">
            <div class="append-text bg-warning cursor-pointer" @click="search">
              <feather-icon icon="SearchIcon"></feather-icon>
            </div>
          </template>
        </vx-input-group>
      </div>

      <vs-table stripe :data="list" noDataText="暂无注册链接">
        <template slot="thead">
          <vs-th width="120">UID</vs-th>
          <vs-th width="200">用户名</vs-th>
          <vs-th width="250">人数</vs-th>
          <vs-th width="250">用户组</vs-th>
          <vs-th width="300">备注</vs-th>
          <vs-th width="300">操作</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(item, index) in list" >
            <vs-td :data="item.id">{{item.uid}}</vs-td>
            <vs-td :data="item.user.username">{{item.user.username}}</vs-td>
            <vs-td :data="item.maxCount">{{item.maxCount}}</vs-td>
            <vs-td :data="item.group.name">{{item.group.name}}</vs-td>
            <vs-td :data="item.remark">{{item.remark}}</vs-td>
            <vs-td>
              <vs-button color="success" type="filled" size="small" @click="copy" :data-index="index" class="ml-5">复制</vs-button>
              <vs-button color="danger" type="filled" size="small" @click="del" :data-index="index" class="ml-5">删除</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <input id="copyInput" :value="copyLink" style="opacity: 0;" />

      <vs-pagination class="mt-6" :total="totalPage" v-model="page" goto />
    </vx-card>

  </div>
</template>

<script>

export default {
  data() {
    return {
      uid: '',
      page: 1,
      totalPage: 1,
      list: [],
      setting: {},
      copyLink: ''
    }
  },
  methods: {
    copy (e) {
      const index = e.currentTarget.dataset.index
      const key = this.list[index].key
      const input = document.getElementById('copyInput')
      input.value = this.setting.pcUrl + 'register?id=' + key
      input.select()
      document.execCommand('Copy')
      this.$vs.dialog({
        title: '提示',
        text: '复制成功',
        acceptText: '确认'
      })
    },
    del (e) {
      const index = e.currentTarget.dataset.index
      const postdata = {}
      postdata.id = this.list[index].id
      postdata.authKey = localStorage.getItem('authKey')
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '确认',
        text: '确认删除该链接吗?',
        acceptText: '确认',
        cancelText: '取消',
        accept: () => {
          this.$utils.post('user-linkDelete', postdata).then(res => {
            this.$vs.dialog({
              title: '提示',
              text: res,
              acceptText: '确认'
            })
            this.list.splice(index, 1)
          })
        }
      })
    },
    search() {
      this.page = 1
      this.load()
    },
    load() {
      const postdata = {}
      postdata.authKey = localStorage.getItem('authKey')
      postdata.uid = this.uid
      postdata.page = this.page
      this.$utils.post('user-linkList', postdata).then(res => {
        this.list = res.list
        this.totalPage = Math.ceil(res.count / res.pagesize)
      })
    }
  },
  watch: {
    page(newValue) {
      this.page = newValue
      this.load()
    }
  },
  mounted () {
    this.load()

    // 读取设置
    this.$utils.post('setting-base', { authKey: localStorage.getItem('authKey') }).then(res => {
      const setting = {}
      let s
      for (let i = 0; i < res.setting.length; i++) {
        s = res.setting[i]
        setting[s.name] = s.value
      }
      this.setting = setting
    })
  }
}
</script>
